
export default {
  default() {
    return {
    }
  },

  forSimple(data) {
    return { 
      id: data.id,
      name: data.name,
      lastName: data.lastName,
      email: data.email,
      phone: data.phone
    }
  },

  forCreate(data) {
    return {
      ...data
    };
  },

  forUpdate(data) {
    return {
      ...data
    };
  }
};



// WEBPACK FOOTER //
// ./src/entities/field-manager/field-manager-model.js